import { getCookie } from "@/utils"

export default {
  created() {
    const sid = getCookie('sid')
    if (!sid) {
      window.location.href = `//member.chinaacc.com/member/loginAgain.shtm?validateLogin=n&gotoURL=${ encodeURIComponent(process.env.VUE_APP_RELEASE_URL) }`
    } else {
      // window.location.href = `${ process.env.VUE_APP_RELEASE_URL }`
    }
  }
}
